<template>
  <DelDialog
    width="1100px"
    :dialogVisible="visible"
    @handleClose="handleCancel"
    @handleConfirm="handleConfirm"
  >
    <template #title>{{$t('assignTaskV2.allocateTask')}}</template>
    <div class="assign-content">
      <div class="content-header">
        <el-button @click="handleManage" type="primary" plain>{{$t('assignTaskV2.memberManagement')}}</el-button>
        <el-input @keyup.native.enter="handleSearch" clearable @change="searchChange" v-model="searchUser" :placeholder="$t('assignTaskV2.searchMember')"></el-input>
      </div>
      <div class="content-table">
        <el-table
          border
          v-loading="loading"
          height="100%"
          :data="userList"
          header-row-class-name="customHeader"
        >
          <el-table-column
            :label="$t('assignTaskV2.orderNumber')"
            align="center"
            width="60px"
          >
            <template slot-scope="{ $index }">
              {{$index + 1}}
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('assignTaskV2.name')"
            align="center"
            prop="aliasName"
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column
            :label="$t('assignTaskV2.email')"
            align="center"
            width="250"
            prop="email"
            show-overflow-tooltip
          >
            <template slot-scope="{row}">
              {{row.email || '--'}}
            </template>
          </el-table-column>
          <!-- 独立部署显示为邮箱，飞译都显示 -->
          <el-table-column
            :label="$t('assignTaskV2.phone')"
            align="center"
            prop="loginPhone"
            v-if="!(IS_PRIVATE || IS_ONLINE_PRIVATE)"
            show-overflow-tooltip
          >
            <template slot-scope="{row}">
              {{row.loginPhone || '--'}}
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('assignTaskV2.yetTask')"
            align="center"
            prop="transTaskNumber"
          >
          </el-table-column>

          <el-table-column
            :label="$t('assignTaskV2.yetFont')"
            align="center"
            prop="transWordNumber"
            min-width="150"
          >
          </el-table-column>

          <el-table-column
            :label="$t('assignTaskV2.manipulate')"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-radio v-model="checkUser" :label="row.userId">{{''}}</el-radio>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </DelDialog>
</template>

<script>
import _ from 'lodash';

import { assignTask, querySelfUserList } from '@/services/assignTaskApi';

import DelDialog from '@/components/delDialog';
import { mapActions } from 'vuex';

export default {
  name: 'Assign',
  components: {
    DelDialog,
  },
  props: {
    visible: {
      type: Boolean,
      require: true,
    },
    selObj: {
      type: Object,
      require: true,
    }
  },
  data () {
    return {
      IS_PRIVATE: IS_PRIVATE,
      IS_ONLINE_PRIVATE: IS_ONLINE_PRIVATE,
      userList: [],
      checkUser: 0,
      searchUser: '',
      loading: true,
    }
  },
  computed:{
    getNavInfo() {
      return (this.$store.getters['layout/getNavInfo'] || [])
    },
  },
  methods: {
    ...mapActions(['getTaskNums']),
    searchChange (val) {
      if (val === '') {
        this.handleSearch();
      }
    },
    async getSelfUserList () {
      let { success, result } = await querySelfUserList({
        isContainSelf: 1,
      });
      this.loading = false;
      if (!success) { return; }
      this.userList = result;
    },
    handleManage () {
      // let { href } = this.$router.resolve({
      //   path: '/home/manage'
      // });
      // window.open(href, '_blank');
    
      this.$router.push({
        path: this.getNavInfo.find(item=>item.code == "team_manage").url
      })
    },
    handleCancel () {
      this.searchUser = '';
      this.checkUser = 0;
      this.$emit('handleCancel');
    },
    handleConfirm: _.throttle(async function () {
      this.$message.closeAll();
      if (this.checkUser === 0) {
        this.$message.warning(this.$t('assignTaskV2.selectMember'));
        return;
      }
      // else if (this.checkUser === this.selObj.userId) {
      //   this.$message.warning('请选择其他成员！');
      //   return;
      // }
      // else if (new Date(this.selObj.limitTime + ':00') < new Date()) {
      //   this.$message.closeAll();
      //   this.$message({
      //     type: 'warning',
      //     message:this.$t('assignTaskV2.deadtimelessLocatime')
      //   });
      //   return;
      // }
      // else if (new Date(this.selObj.limitTime + ':00') > new Date(this.queryData.deliveryTime + ':00')) {
      //   this.$message.closeAll();
      //   this.$message({
      //     type: 'warning',
      //     message: '截止时间不能超过项目截止时间'
      //   });
      //   return;
      // }
      let param = {
        fileId: this.selObj.fileId,
        limitTime: this.selObj.limitTime,
        taskId: this.selObj.selTaskID,
        taskType: this.selObj.taskType,
        userId: this.checkUser
      };
      let { success } = await assignTask(param);
      this.handleCancel();
      if (!success) { return; }
      this.$message.success(this.$t('assignTaskV2.allocateSuccessed'));
      this.$emit('updateTaskList');
      this.getTaskNums()
    }, 2000, {
      leading: true,
      trailing: false
    }),
    async handleSearch () {
      let { success, result } = await querySelfUserList({
        isContainSelf: 1,
      });
      this.loading = false;
      if (!success) { return; }
      this.userList = result.filter(item => {
        return item.aliasName.indexOf(this.searchUser) !== -1;
      });
    }
  },
  watch: {
    selObj: {
      handler (newVal) {
        this.checkUser = newVal.userId;
      },
      deep: true,
      immediate: true,
    }
  },
}
</script>

<style lang="less" scoped>
  @import './assets/style.less';
</style>